enum ActionTypes {
  LAYOUT_HIDE_NAVIGATION = 'LAYOUT_HIDE_NAVIGATION',
  LAYOUT_SHOW_NAVIGATION = 'LAYOUT_SHOW_NAVIGATION'
}

export default ActionTypes;
